import { render, staticRenderFns } from "./Bahn1EventInfo.vue?vue&type=template&id=69927462&scoped=true&"
import script from "./Bahn1EventInfo.vue?vue&type=script&lang=js&"
export * from "./Bahn1EventInfo.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1EventInfo.vue?vue&type=style&index=0&id=69927462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69927462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
